import React from 'react'
import {
  Backdrop,
  Box,
  CircularProgress,
  Container,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow
} from '@mui/material'
import EditIcon from '@mui/icons-material/Edit'
import { useTypePosition } from '../../context'
import { TableHeader } from '../../../UI/Table/TableHeader'

import { headCells } from './typePositionConfig'
import { PaginationTable } from '../../../UI/Table/TablePagination'
import { useStyles } from './styles'
import { Loading, SearchCriteriaPanel } from '../../../UI'
import { TypePosition } from '../../types/TypePosition'
import typePositionBusiness from '../../actions/typePositionBusiness'

interface TypePositionListProps {}

const TypePositionList: React.FC<TypePositionListProps> = () => {
  const {
    state: { loading, rows, totalItems, page, pageSize }
  } = useTypePosition()

  const { openEditModal } = typePositionBusiness()

  const { handleChangePage, handleChangeRowsPerPage } = typePositionBusiness()

  // Se solicitó que el tipo de posición TRANSITO (id 2) no pueda ser editado
  // const nonEditableTypePositions = [2, 4, 5, 6, 7, 9, 10, 11, 12, 14, 15, 16]

  const classes = useStyles()

  if (rows.length === 0) {
    return (
      <Container maxWidth='xl'>
        {loading ? <Loading /> : <SearchCriteriaPanel elevation={0} />}
      </Container>
    )
  }

  return (
    <Paper elevation={3}>
      <Box className={classes.flexContainer}>
        <Box className={classes.tableContainer}>
          <TableContainer style={{ position: 'relative' }}>
            <Backdrop className={classes.backdrop} open={loading}>
              <CircularProgress color='inherit' />
            </Backdrop>
            <Table
              className={classes.table}
              aria-labelledby='tableTitle'
              size={'small'}
              aria-label='enhanced table'
            >
              <TableHeader
                numSelected={0}
                onSelectAllClick={() => {}}
                orderInitial='asc'
                orderByInitial='typePositionCode'
                rowCount={rows.length}
                sorters={[]}
                setSorters={() => {}}
                headCells={headCells}
              />

              <TableBody>
                {rows.map((element: TypePosition) => {
                  return (
                    <TableRow>
                      <TableCell>{element.typePositionId}</TableCell>
                      <TableCell>{element.typePositionCode}</TableCell>
                      <TableCell>{element.typePositionDescription}</TableCell>
                      <TableCell>
                        {element.considerInventory ? 'Si' : 'No'}
                      </TableCell>
                      <TableCell>{element.requireZone ? 'Si' : 'No'}</TableCell>
                      <TableCell>
                        <IconButton
                          disabled={!element.isEditable}
                          aria-label='edit'
                          onClick={() =>
                            openEditModal(true, element.typePositionId)
                          }
                        >
                          <EditIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  )
                })}
              </TableBody>
            </Table>
            <PaginationTable
              pagination={{ page, totalItem: totalItems, pageSize }}
              handleChangePage={handleChangePage}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
            />
          </TableContainer>
        </Box>
      </Box>
    </Paper>
  )
}

export default TypePositionList
